module.exports = __webpack_public_path__ + "assets/img/u782.e96880d5.svg";